import React from "react";
import CustomButton from "../../../../../../shared_components/CustomButton";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaNetworkWired, FaRegCalendar } from "react-icons/fa6";

const steps = [
    {
        id: 1,
        icon: < FaRegCalendar size={24} />,
        title: "Subheading one",
        desc: "Share your campus goals and what kind of event resonates with your students.",
    },
    {
        id: 2,
        icon: <FaNetworkWired size={24} />,
        title: "Subheading two",
        desc: "We collaborate on logistics, speakers, timing, and everything in between.",
    },
    {
        id: 3,
        icon: < FaRegCalendar size={24} />,
        title: "Subheading three",
        desc: "Your event happens. Students learn. Memories are made. We handle it all.",
    },
    {
        id: 4,
        icon: < FaRegCalendar size={24} />,
        title: "Subheading four",
        desc: "Your event happens. Students learn. Memories are made. We handle it all.",
    },
];

const ProcessSection = () => {
    return (
        <section className="row mx-0 d-flex justify-content-center my-5">
            <div className="col-12 col-md-10">
                <div className="row mx-0">
                    <div className="col-12 col-md-6">
                        <h6 className="fs-14">Process</h6>
                        <h1 className="fw-bold">
                            Three steps to bring <br /> Datacode to campus
                        </h1>
                        <div className="mt-3">
                            <CustomButton className="bg-transparent border text-dark">Button</CustomButton>
                            <a className="ml-3 text-dark">
                                Button <MdKeyboardArrowRight />
                            </a>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        {steps.map((item, index) => (
                            <div className="d-flex mb-4" key={item.id}>
                                <div className="d-flex flex-column align-items-center mr-3">
                                    <div>{item.icon}</div>
                                    {index !== steps.length - 1 && (
                                        <div className="mt-3 timeline-line" />
                                    )}
                                </div>

                                <div>
                                    <h6>{item.title}</h6>
                                    <p >{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;
